import script from "./TokenSelectInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenSelectInput.vue?vue&type=script&setup=true&lang=ts"

import "./TokenSelectInput.vue?vue&type=style&index=0&id=dd64c6f4&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd64c6f4"]])

export default __exports__